import React from "react"
import { Route } from "react-router-dom"
import RedirectToLogin from "./redirect-to-login"
import RedirectToSettings from "./redirect-to-settings"

const PrivateRoute = ({ component: Component, isAuthenticated, passwordUpdateRequired, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated ? (
        passwordUpdateRequired === true && window.location.pathname !== "/settings" ? (
          <RedirectToSettings {...props} />
        ) : (
          <Component {...props} />
        )
      ) : (
        <RedirectToLogin {...props} />
      )
    }
  />
)

export default PrivateRoute
